import { Spinner } from 'react-bootstrap'

export function LoadingSpinner() {
    return (
        <div className="d-flex justify-content-center mt-3">
            <Spinner animation="border" variant="primary" />
        </div>
    )
}
